import salesFollowup from "./SalesFollowup";
const arr = [
  { label: "None", template: "<B><em>No Template<em></B>", value: 0 },
  { label: "SalesFollowup", template: salesFollowup, value: 1 },
];

export default arr;
